import { render, staticRenderFns } from "./StatisticsVisitor.vue?vue&type=template&id=fc1977a2&scoped=true"
import script from "./StatisticsVisitor.vue?vue&type=script&lang=js"
export * from "./StatisticsVisitor.vue?vue&type=script&lang=js"
import style0 from "./StatisticsVisitor.vue?vue&type=style&index=0&id=fc1977a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1977a2",
  null
  
)

export default component.exports